import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import type { ReactNode } from "react";
import type {
  FacilityTerminalDto,
  TerminalItemDto,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { FacilityTerminalsList } from "Components/Merchants/OrbitLOnboarding/FacilityTerminalsList";
import { SwapTerminalDialog } from "Components/Merchants/OrbitLOnboarding/SwapTerminalDialog";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  merchantPublicID: string;
  facilityTerminals: Array<FacilityTerminalDto>;
};

export const TerminalsSection = ({
  merchantPublicID,
  facilityTerminals,
}: Props) => {
  const { t } = useResource();
  const [swapTarget, setSwapTarget] = useState<TerminalItemDto | null>(null);

  const nonEmptyTerminals = facilityTerminals.filter(
    ({ terminals }) => terminals.length > 0,
  );

  if (nonEmptyTerminals.length === 0) {
    return (
      <Layout>
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.NoTerminals)}
        </Typography>
      </Layout>
    );
  }

  return (
    <>
      <Layout>
        <FacilityTerminalsList
          facilityTerminals={nonEmptyTerminals}
          onSwapClick={setSwapTarget}
        />
      </Layout>

      {swapTarget && (
        <SwapTerminalDialog
          target={swapTarget}
          merchantPublicID={merchantPublicID}
          onClose={() => setSwapTarget(null)}
        />
      )}
    </>
  );
};

const Layout = ({ children }: { children: ReactNode }) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">
        {t(RESOURCES.TerminalsSection)}
      </Typography>
      {children}
    </Stack>
  );
};
